import { commitMutation, graphql } from "react-relay";
import environment from "../AuthEnv";
import { GC_AUTH_TOKEN, GC_USER_ID, GRAPHQL_PATH } from "../constants";
import { ConnectionHandler } from "relay-runtime";

const mutation = graphql`
	mutation DeleteNoteMutation($input: DeleteNoteInput!) {
		deleteNote(input: $input) {
			deletedNoteId
		}
	}
`;

function sharedUpdater(store, deletedNoteId) {
	const userProxy = store.get(localStorage.getItem(GC_USER_ID));
	const connection = ConnectionHandler.getConnection(
		userProxy,
		"NoteView_notes"
	);

	if (connection) {
		ConnectionHandler.deleteNode(connection, deletedNoteId);
	}
}

export default (postId, noteIdString, noteId, callback) => {
	const variables = {
		input: {
			noteId: noteIdString,
			postId: postId
		}
	};

	commitMutation(environment, {
		mutation,
		updater(store) {
			const payload = store.getRootField("deleteNote");
			sharedUpdater(store, payload.getValue("deletedNoteId"));
		},
		optimisticUpdater(store) {
			sharedUpdater(store, noteId);
		},
		variables,
		onCompleted: (response, errors) => {
			if (response.deleteNote != null) {
				callback();
			} else {
				console.log("Unable to delete note!");
			}
		},
		onError: err => console.error(err)
	});
};
